import FColumnCellMDP from '../FColumnCellMDP';
export default class FCellBooleanMDP implements FColumnCellMDP {
    type?: BooleanCellType = BooleanCellType.Normal;
    successColor?: string;
    errorColor?: string;
    outlined?: boolean;
    hideFalseValue?: boolean;
    successText?: string;
    errorText?: string;
    constructor(props: {
        type?: BooleanCellType;
        successColor?: string;
        errorColor?: string;
        outlined?:boolean;
        hideFalseValue?: boolean;
        successText?: string;
        errorText?: string;
    }) {
        this.type = props.type;
        this.successColor = props.successColor||"green";
        this.errorColor = props.errorColor||"#F5885B";
        this.outlined = props.outlined;
        this.hideFalseValue = props.hideFalseValue;
        this.successText = props.successText;
        this.errorText = props.errorText;
    }
    componentName: string = "FCellBoolean";
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                type: this.type,
                successColor: this.successColor,
                errorColor: this.errorColor,
                outlined: this.outlined,
                hideFalseValue: this.hideFalseValue,
                errorText: this.errorText,
                successText: this.successText
            }
        }
    }

}

export enum BooleanCellType {
    Normal="Normal",
    Dotted="Dotted",
    BoldText="BoldText"
}